"use strict";
// This file describes the messages that the Client can send to the Server
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectGameMessage = exports.ContestantSubmission = exports.ContestantWager = exports.ContestantSpectate = exports.ContestantJoin = exports.ContestantBuzzIn = exports.ContestantRemoveMessage = exports.RevealMessage = exports.CloseSubmissionsMessage = exports.CloseWagersMessage = exports.OpenBuzzer = exports.CloseClueMessage = exports.SetScoreMessage = exports.ModifyScoreMessage = exports.SelectClueMessage = exports.StartGameMessage = exports.TrebekJoinMessage = exports.ClientMessage = exports.ClientMessageType = void 0;
var ClientMessageType;
(function (ClientMessageType) {
    ClientMessageType[ClientMessageType["START_GAME"] = 0] = "START_GAME";
    ClientMessageType[ClientMessageType["SELECT_CLUE"] = 1] = "SELECT_CLUE";
    ClientMessageType[ClientMessageType["TREBEK_JOIN"] = 2] = "TREBEK_JOIN";
    ClientMessageType[ClientMessageType["MODIFY_SCORE"] = 3] = "MODIFY_SCORE";
    ClientMessageType[ClientMessageType["SET_SCORE"] = 4] = "SET_SCORE";
    ClientMessageType[ClientMessageType["CONTESTANT_JOIN"] = 5] = "CONTESTANT_JOIN";
    ClientMessageType[ClientMessageType["CONTESTANT_BUZZ"] = 6] = "CONTESTANT_BUZZ";
    ClientMessageType[ClientMessageType["CONTESTANT_WAGER"] = 7] = "CONTESTANT_WAGER";
    ClientMessageType[ClientMessageType["CONTESTANT_SPECTATE"] = 8] = "CONTESTANT_SPECTATE";
    ClientMessageType[ClientMessageType["CONTESTANT_SUBMISSION"] = 9] = "CONTESTANT_SUBMISSION";
    ClientMessageType[ClientMessageType["CONTESTANT_REMOVE"] = 10] = "CONTESTANT_REMOVE";
    ClientMessageType[ClientMessageType["CLOSE_CLUE"] = 11] = "CLOSE_CLUE";
    ClientMessageType[ClientMessageType["CLOSE_SUBMISSIONS"] = 12] = "CLOSE_SUBMISSIONS";
    ClientMessageType[ClientMessageType["CLOSE_WAGERING"] = 13] = "CLOSE_WAGERING";
    ClientMessageType[ClientMessageType["OPEN_BUZZER"] = 14] = "OPEN_BUZZER";
    ClientMessageType[ClientMessageType["REVEAL"] = 15] = "REVEAL";
    ClientMessageType[ClientMessageType["SELECT_GAME"] = 16] = "SELECT_GAME";
})(ClientMessageType || (exports.ClientMessageType = ClientMessageType = {}));
class ClientMessage {
    constructor(id) {
        this.id = id;
    }
}
exports.ClientMessage = ClientMessage;
/* ====================== Trebek Side ================== */
class TrebekJoinMessage extends ClientMessage {
    constructor(id) {
        super(id);
        this.type = ClientMessageType.TREBEK_JOIN;
    }
}
exports.TrebekJoinMessage = TrebekJoinMessage;
// Tells the server to make a new game with game id <id>
class StartGameMessage extends ClientMessage {
    constructor(id, airdate) {
        super(id);
        this.type = ClientMessageType.START_GAME;
        this.airdate = airdate;
    }
}
exports.StartGameMessage = StartGameMessage;
// Tells the server to transition a clue on a jeopardy board to the INPLAY state
class SelectClueMessage extends ClientMessage {
    constructor(id, clueId) {
        super(id);
        this.clueId = clueId;
        this.type = ClientMessageType.SELECT_CLUE;
    }
}
exports.SelectClueMessage = SelectClueMessage;
// Modify Score
class ModifyScoreMessage extends ClientMessage {
    constructor(id, scoreDelta, teamName) {
        super(id);
        this.teamName = teamName;
        this.scoreDelta = scoreDelta;
        this.type = ClientMessageType.MODIFY_SCORE;
    }
}
exports.ModifyScoreMessage = ModifyScoreMessage;
// Set Score
class SetScoreMessage extends ClientMessage {
    constructor(id, newScore, teamName) {
        super(id);
        this.teamName = teamName;
        this.newScore = newScore;
        this.type = ClientMessageType.SET_SCORE;
    }
}
exports.SetScoreMessage = SetScoreMessage;
// Close Clue
class CloseClueMessage extends ClientMessage {
    constructor(id) {
        super(id);
        this.type = ClientMessageType.CLOSE_CLUE;
    }
}
exports.CloseClueMessage = CloseClueMessage;
// Trebek allows contestants to buzz in
class OpenBuzzer extends ClientMessage {
    constructor(id) {
        super(id);
        this.type = ClientMessageType.OPEN_BUZZER;
    }
}
exports.OpenBuzzer = OpenBuzzer;
// End current wagering period
class CloseWagersMessage extends ClientMessage {
    constructor(id) {
        super(id);
        this.type = ClientMessageType.CLOSE_WAGERING;
    }
}
exports.CloseWagersMessage = CloseWagersMessage;
// End period where contestants submit responses
class CloseSubmissionsMessage extends ClientMessage {
    constructor(id) {
        super(id);
        this.type = ClientMessageType.CLOSE_SUBMISSIONS;
    }
}
exports.CloseSubmissionsMessage = CloseSubmissionsMessage;
class RevealMessage extends ClientMessage {
    constructor(id, teamName) {
        super(id);
        this.teamName = teamName;
        this.type = ClientMessageType.REVEAL;
    }
}
exports.RevealMessage = RevealMessage;
// Remove a contestant from a Jeopardy session
class ContestantRemoveMessage extends ClientMessage {
    constructor(id, teamName) {
        super(id);
        this.teamName = teamName;
        this.type = ClientMessageType.CONTESTANT_REMOVE;
    }
}
exports.ContestantRemoveMessage = ContestantRemoveMessage;
/* ==================== Contestant Side ============================ */
class ContestantBuzzIn extends ClientMessage {
    constructor(id, teamName, timeToBuzz) {
        super(id);
        this.teamName = teamName;
        this.timeToBuzz = timeToBuzz;
        this.type = ClientMessageType.CONTESTANT_BUZZ;
    }
}
exports.ContestantBuzzIn = ContestantBuzzIn;
class ContestantJoin extends ClientMessage {
    constructor(id, teamName, playerName) {
        super(id);
        this.teamName = teamName;
        this.playerName = playerName;
        this.type = ClientMessageType.CONTESTANT_JOIN;
    }
}
exports.ContestantJoin = ContestantJoin;
class ContestantSpectate extends ClientMessage {
    constructor(id) {
        super(id);
        this.type = ClientMessageType.CONTESTANT_SPECTATE;
    }
}
exports.ContestantSpectate = ContestantSpectate;
class ContestantWager extends ClientMessage {
    constructor(id, teamName, wager) {
        super(id);
        this.wager = wager;
        this.teamName = teamName;
        this.type = ClientMessageType.CONTESTANT_WAGER;
    }
}
exports.ContestantWager = ContestantWager;
class ContestantSubmission extends ClientMessage {
    constructor(id, teamName, submission) {
        super(id);
        this.teamName = teamName;
        this.submission = submission;
        this.type = ClientMessageType.CONTESTANT_SUBMISSION;
    }
}
exports.ContestantSubmission = ContestantSubmission;
class SelectGameMessage extends ClientMessage {
    constructor(id, gameName) {
        super(id);
        this.gameName = gameName;
        this.type = ClientMessageType.SELECT_GAME;
    }
}
exports.SelectGameMessage = SelectGameMessage;
//# sourceMappingURL=clientToServerMsgs.js.map